import { render } from "./PlanFbwa.vue?vue&type=template&id=292d775e"
import script from "./PlanFbwa.vue?vue&type=script&lang=js"
export * from "./PlanFbwa.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__